import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { PropertyStickyBookBar } from '@shared-ui/lodging-property-offers';
import { withSharedUiPropertyOffers } from './shared-ui-property-offers';
import { SingleOfferSearchForm } from '../../single-offer-search';
export const StickyBookBarWrapper = inject('currentHotel', 'multiItem')(observer(({
  inputs,
  multiItem
}) => {
  var _a;
  // Used for H+H use case
  if ((_a = multiItem === null || multiItem === void 0 ? void 0 : multiItem.cartInfo) === null || _a === void 0 ? void 0 : _a.id) {
    return null;
  }
  return React.createElement(PropertyStickyBookBar, {
    inputs: inputs,
    focusTargetRef: "Offers",
    skipSsr: true
  }, React.createElement(SingleOfferSearchForm, null));
}));
StickyBookBarWrapper.displayName = 'StickyBookBarWrapper';
export const SharedUiStickyBookBarWrapper = withSharedUiPropertyOffers(StickyBookBarWrapper);